import { useAppSelector } from 'store/hooks';
const useAccount = () => useAppSelector((state) => state.pots.account);
export default useAccount;
